<template>
  <!-- <div class="blog_subtitle-category" style="white-space: nowrap">
    <a
      class="title"
      v-for="(item, ix) in menuList"
      :key="ix"
      :class="{ current: current == item.id }"
      @click="changeMenu(item.id, item.sgL_NewName)"
    >
      {{ item.sgL_NewName }}
    </a>
  </div> -->
  <div class="blog_subtitle-category" style="white-space: nowrap">
    <el-select
      v-model="current"
      :placeholder="$t('blog.menu.placeholder')"
      @change="changeMenu($event)"
      style="width: 100%"
    >
      <el-option
        v-for="item in menuList"
        :key="item.id"
        :label="item.sgL_NewName"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: "",
      menuList: [],
    };
  },
  created() {
    if (this.$route.query.categoryId) {
      this.current = this.$route.query.categoryId;
    }
    this.$store.dispatch("getCommonTypeDesk", 70).then((res) => {
      this.menuList = res; //活動類型
      this.menuList.unshift({
        id: "",
        sgL_NewName: "全部",
      });
    });
  },
  methods: {
    setCurrent(ix) {
      this.current = ix;
    },
    changeMenu(ix) {
      const info = this.menuList.find((c) => c.id === ix);
      let name = "";
      if (info) {
        name = info.sgL_NewName;
      }
      this.$emit("changeMenu", ix, name);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/blog/menu.vue